import dialog from './dialog/dialog';
import dialogService from './dialog-service';
import survey from './survey';
import surveyConfirmation from './survey-confirmation';
import surveyService from './survey-service';
import surveyWithSlash from './survey-with-slash';

export default function(app) {
    survey(app);
    surveyConfirmation(app);
    surveyWithSlash(app);
    app.service('dialogService', dialogService);
    app.service('surveyService', surveyService);
    app.controller('dialogController', dialog);
};



// WEBPACK FOOTER //
// ./app/components/index.js